import _this from '../../../../main';
export const reportSubmit=(data)=>{
  let value;
  if(Array.isArray(data)){
    value=data.join();
  }else if(_this.$moment.isMoment(data)){
    value=data.unix();
  }else{
    value=data;
  }
  return value;
};